<template>
  <footer class="footer">
    <el-divider></el-divider>
    <!-- <div class="box">
      <div id="phoneLink" class="first-line" v-for="(item, index) in arr1" :key="index" @click="toPage(item)">
        <el-link class="text">{{ item }}</el-link>
        <el-divider direction="vertical" v-if="index != arr1.length - 1"></el-divider>
      </div>
    </div> -->
    <div class="box">
      <div class="second-line" v-for="(item, index) in arr4" :key="index" @click="toArr4()">
        <span class="text">
          {{ item }}
        </span>
        <el-divider direction="vertical" v-if="index != arr4.length - 1"></el-divider>
      </div>
    </div>
    <div class="box">
      <div class="second-line" v-for="(item, index) in arr2" :key="index" @click="toArr2(index)">
        <span class="text">{{ item }}</span>
        <el-divider direction="vertical" v-if="index != arr2.length - 1"></el-divider>
      </div>
    </div>
    <div class="box">
      <div class="second-line" v-for="(item, index) in arr11" :key="index" @click="toArr2(index)">
        <span class="text">{{ item }}</span>
        <el-divider direction="vertical" v-if="index != arr11.length - 1"></el-divider>
      </div>
    </div>
    <div class="box">
      <div class="second-line" v-for="(item, index) in arr6" :key="index" @click="toFiling()">
        <span class="text">
          {{ item }}
        </span>
        <el-divider direction="vertical" v-if="index != arr6.length - 1"></el-divider>
      </div>
    </div>
    <div class="box">
      <div class="second-line" v-for="(item, index) in arr7" :key="index" @click="toPage(item)">
        <span class="text">
          {{ item }}
        </span>
        <el-divider direction="vertical" v-if="index != arr7.length - 1"></el-divider>
      </div>
    </div>
    <div class="box">
      <div class="second-line" v-for="(item, index) in arr8" :key="index" @click="toPage(item)">
        <span class="text">
          {{ item }}
        </span>
        <el-divider direction="vertical" v-if="index != arr8.length - 1"></el-divider>
      </div>
    </div>
    <div class="box">
      <div class="second-line" v-for="(item, index) in arr9" :key="index" @click="toPage(item)">
        <span class="text">
          {{ item }}
        </span>
        <el-divider direction="vertical" v-if="index != arr9.length - 1"></el-divider>
      </div>
    </div>
    <div class="box">
      <div class="second-line" v-for="(item, index) in arr10" :key="index" @click="toJump(index)">
        <span class="text">
          {{ item }}
        </span>
        <el-divider direction="vertical" v-if="index != arr10.length - 1"></el-divider>
      </div>
    </div>
    <div class="box">
      <div class="second-line" style="display: flex;align-items: center;" v-for="(item, index) in arr3" :key="index">
        <img style="width: 18px;height: 18px;margin-right: 5px;" src="https://beian.mps.gov.cn/web/assets/logo01.6189a29f.png" alt="">
        <span class="text">
          {{ item }}
        </span>
        <el-divider direction="vertical" v-if="index != arr3.length - 1"></el-divider>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'MyFooter',
  data() {
    return {
      arr1: [
        '关于我们',
        '联系我们',
        '联系客服',
        '合作招商',
        '商家帮助',
        '隐私政策',
      ],
      arr2: [
        '增值电信业务经营许可证',
        '药品网络交易服务第三方平台备案证：（京）网药平台备字〔2025〕第 000015 号',
        '医疗器械网络交易服务第三方平台备案证：（京）网械平台备字〔2025〕第 00012 号'
      ],
      arr3: [
        '京公网安备11010502057811号'
      ],
      arr4: [
        '《营业执照》统一社会信用代码 91110105MA01W2NK82',
      ],
      arr11:[
        '药品医疗器械网络信息服务备案: (京)网药械信息备字(2023)第00040号'
      ],
      arr6: [
        '@2020-2025 北京明医云科技股份有限公司 版权所有  京ICP备2020040000号-3'
      ],
      arr7: [
        '公司地址：北京市朝阳区五里桥二街2号院1号楼1层0120网络运营中心'
      ],
      arr8: [
        '本网站不从事麻醉药品、精神药品、医疗用毒性药品、放射性药品、戒毒药品和医疗机构制剂等产品的交易'
      ],
      arr9: [
        '本公司网站不得发布未经国家批准的药品广告信息'
      ],
      arr10: [
        '监管部门: 国家药品监督管理局', '北京市药品监督管理局'
      ]
    };
  },
  methods: {
    //营业执照
    toArr4() {
      window.open('https://myy-one-stand.oss-accelerate.aliyuncs.com/auth/1765348750.pdf')
    },
    //增值电信业务经营许可证 药品备案 器械备案
    toArr2(index) {
      if (index == 1) {
        window.open('https://myy-one-stand.oss-accelerate.aliyuncs.com/auth/1763437232.pdf')
      } else if (index == 2) {
        window.open('https://myy-one-stand.oss-accelerate.aliyuncs.com/auth/1763437272.pdf')
      } else {
        window.open('https://myy-one-stand.oss-accelerate.aliyuncs.com/auth/1763437673.pdf')
      }
    },
    //ICP备案
    toFiling() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index')
    },
    //国家药品监督管理局 北京市药品监督管理局
    toJump(index) {
      if (index == 1) {
        window.open('https://yjj.beijing.gov.cn/')
      } else {
        window.open('https://www.nmpa.gov.cn/')
      }
    },
    toPage(item) {
      if (item == '关于我们') {

      } else if (item == '联系我们') {
        this.callPhone()
      } else if (item == '联系客服') {
        this.callPhone()
      } else if (item == '合作招商') {

      } else if (item == '商家帮助') {
        this.callPhone()
      } else if (item == '隐私政策') {

      }
    }
  }
};
</script>

<style scoped>
.footer {
  background: #fff;
  width: 100%;
  /* position: fixed;
  bottom: 0;
  left: 0; */
}

.footer .box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 5px;
}

.footer .first-line {
  color: #666;
  font-size: 14px;
}

.footer {
  color: #999;
  font-size: 13px;
  padding-bottom: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/PC/footer/MyFooter.vue